/**
 * 用户权限
 *  code 功能code
 *  condition 判断条件 最终结果 true 有权限||false无权限
 */
import { getServicePhone } from "@/utils/common";
import { CookieKeys, Cookies } from "@/utils/cookieKey";

export const AUTH_KEY_MAP = {
  TIME_CUSTOM: "time-custom",
  VIP_SELECT: "vip-select",
  SEARCH_KEYWORDS: "search-keywords",
  NEWBIE_TASK_COMPANY_MONITOR_VISIBLE: "newbie-task-company-monitor-visible",
  COMPANY_ANALYSE_RIGHT: "company_analyse_right",
  SEARCH_COMPANY_NAME: "search_company_name",
  SEARCH_COMPANY_MORE_CONTACT: "search_company_more_contact",
  EXPORTMENU: "export_menu",
  SIDEBAR_ONLINE_CONSULT: "sidebar_online_consult",
  SIDEBAR_PRESALE_CONSULT: "sidebar_presale_consult",
  VIP_CUSTOM_SERVICE_PHONE_NUM: "vip_custom_service_phone_num",
  SEARCH_FREE_COMPANY: "search_free_company",
  MONITOR_PARTY_POWER: "monitor_party_power",
  OPEN_ANALYSE: "open_anaylyse",
  SEARCH_INDUSTRY_CLASSIFICATION: "search_industry_classification",
  DETAILS_SUMMARY_VISIBLE: "detail_summary_visible",
  ANALYSE_SHOW: "analyse_show",
  SEARCH_LIST_INDUSTRY: "search_list_industry",
  HOME_ENTERPRISE_MONITORING: "home_enterprise_monitoring",
  NEW_USER_TASK: "new-user-task",
  HELP_CENTER_ENTRY: "help-center-entry",
  UPGRADE_BTN: "upgrade-btn",
  DEFAULT_SEARCH_MODE: "default-search-mode",
  FOLLOW_SUGGESTION: "follow-suggestion",
  SUMMARY_TYPE: "summary-type",
  COMMON_SEARCH_SAVE: "common-search-save",
  SEARCH_GRAY: "search-gray",
  VIP_CENTER_V28: "vip-center-v28",
  IS_PAID_USERS: "is_paid_users",
  EXPIRE_DATE_VISIBLE: "expire-date-visible",
  IS_ORDINARY_MEMBER: "is-ordinary-member",
  SUBSCRIBE_CENTER_BUSINESS_APPLICATION_MODE: "is-subscribe-center-business-application-mode",
  SUBSCRIBE_CREATE_PERMISSION: "subscribe-create-permission",
  SATISFACTION_SURVEY_MODE: "satisfaction-survey-mode",
  NEW_SUBSCRIBE_GRAY: "new-subscribe-gray",
  NEW_SUBSCRIBE_VERSION_ONE: "new-subscribe-version-one",
  SUBSCRIBE_SHOW_REMAINING: "subscribe-show-remaining",
  FREE_USERS_CREATE_SUB: "free-users-create-sub",
  MONITOR_SATISFACTION_SURVEY_MODE: "monitor-satisfaction-survey-mode",
  IS_MEMBER: "is-member",
  INFO_HAS_PURCHASE_CHECKED: "info-has-purchase-checked",
  IS_NEW_REGISTER_USER: "is-new-register-user",
  HAS_PRODUCT_SERVICES_HEADER: "has-product-services-header",
};
export const FEATURES_CODE = [
  {
    code: AUTH_KEY_MAP.TIME_CUSTOM, //大搜索时间自定义及往年时间的权限，付费用户才可以使用
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
    err_msg: () => {
      return `该功能仅对付费用户开放, 请联系${getServicePhone()}升级会员!`;
    },
  },
  {
    code: AUTH_KEY_MAP.NEWBIE_TASK_COMPANY_MONITOR_VISIBLE, // 新手任务《监控目标企业》可见性
    rules: (store) => store.getters["basic/userInfo"].roleId !== 2,
    err_msg: "",
  },
  {
    code: AUTH_KEY_MAP.COMPANY_ANALYSE_RIGHT, //大搜索搜索公司名称，付费用户展示该模块
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
    err_msg: "",
  },
  {
    code: AUTH_KEY_MAP.SEARCH_COMPANY_NAME, //大搜索搜索公司名片，点击公司名称是否有权限
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
    err_msg: "",
  },
  {
    code: AUTH_KEY_MAP.SEARCH_COMPANY_MORE_CONTACT, //大搜索搜索公司名片，点击更多联系人是否有权限
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
    err_msg: "",
  },
  {
    code: AUTH_KEY_MAP.EXPORTMENU, //导出是否有权限
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
    err_msg: () => {
      return `您当前暂无权限，请咨询${getServicePhone()}升级会员！`;
    },
  },
  {
    code: AUTH_KEY_MAP.SIDEBAR_ONLINE_CONSULT, // 侧边栏在线咨询按钮
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
    err_msg: "",
  },
  {
    code: AUTH_KEY_MAP.SIDEBAR_PRESALE_CONSULT, // 侧边栏售前咨询按钮
    rules: (store) => store.getters["basic/userInfo"].memberLevel <= 5,
    err_msg: "",
  },
  {
    code: AUTH_KEY_MAP.VIP_CUSTOM_SERVICE_PHONE_NUM, // 判断客服电话号码
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      // isPayBefore 该账号是否付费过，1付过 0没付过，子账号同父账号
      return userInfo.isPayBefore || userInfo.memberLevel > 5;
    },
  },
  {
    code: AUTH_KEY_MAP.SEARCH_FREE_COMPANY, //大搜索搜索词，免费用户展示该模块
    rules: (store) => store.getters["basic/userInfo"].memberLevel <= 5,
  },
  {
    code: AUTH_KEY_MAP.MONITOR_PARTY_POWER, //监控甲方权限
    rules: (store) => store.getters["basic/userInfo"].memberLevel <= 5 || store.getters["basic/userInfo"].roleId === 2,
  },
  {
    code: AUTH_KEY_MAP.OPEN_ANALYSE, //免费用户开通企业商情分析
    rules: (store) => store.getters["basic/userInfo"].memberLevel <= 5,
  },
  {
    code: AUTH_KEY_MAP.SEARCH_INDUSTRY_CLASSIFICATION, //大搜行业分类子集是否展示
    rules: (store) => {
      const userId = store.getters["basic/userInfo"].userId.toString();
      const userIdLast = userId.substr(userId.length - 1, 1);
      return userIdLast === "1" || userIdLast === "3" || userIdLast === "5";
    },
  },
  {
    code: AUTH_KEY_MAP.DETAILS_SUMMARY_VISIBLE, // 明细 可见性
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
  },
  {
    code: AUTH_KEY_MAP.ANALYSE_SHOW, // 企业商情分析是否展示
    rules: (store) => store.getters["basic/userInfo"].memberLevel > 5,
  },
  {
    code: AUTH_KEY_MAP.SEARCH_LIST_INDUSTRY, //大搜行业分类子集是否展示
    rules: (store) => {
      const userId = store.getters["basic/userInfo"].userId.toString();
      const userIdLast = (userId + "").substr(userId.length - 1, 1);
      return userIdLast === "7" || userIdLast === "9";
    },
  },
  {
    //HOME_ENTERPRISE_MONITORING 首页企业监控数据
    code: AUTH_KEY_MAP.HOME_ENTERPRISE_MONITORING, //付费用户且不是子子账号展示
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel > 5 && userInfo.roleId !== 2;
    },
  },
  {
    code: AUTH_KEY_MAP.HELP_CENTER_ENTRY, // 帮助中心入口显隐
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel > 5;
    },
  },
  {
    code: AUTH_KEY_MAP.UPGRADE_BTN, // 升级入口显隐
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel <= 5;
    },
  },
  {
    code: AUTH_KEY_MAP.DEFAULT_SEARCH_MODE,
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel > 5;
    },
  },
  {
    code: AUTH_KEY_MAP.FOLLOW_SUGGESTION,
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel >= 52;
    },
  },
  {
    code: AUTH_KEY_MAP.SUMMARY_TYPE,
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel <= 5;
    },
  },
  {
    code: AUTH_KEY_MAP.COMMON_SEARCH_SAVE, // 保存常用搜索
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel > 5;
    },
  },
  {
    code: AUTH_KEY_MAP.IS_PAID_USERS, // 是否是付费用户
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel >= 52;
    },
  },
  {
    code: AUTH_KEY_MAP.EXPIRE_DATE_VISIBLE, // 会员到期时间是否可见
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.showExpireDate && userInfo.memberLevel > 5;
    },
  },
  {
    code: AUTH_KEY_MAP.IS_ORDINARY_MEMBER, // 是否是普通会员
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel > 5 && userInfo.memberLevel < 21;
    },
  },
  {
    code: AUTH_KEY_MAP.SUBSCRIBE_CENTER_BUSINESS_APPLICATION_MODE, //订阅招标查询列表企业商情权限，付费用户
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel > 5;
    },
  },

  {
    code: AUTH_KEY_MAP.SATISFACTION_SURVEY_MODE, //订阅器满意度调研 付费用户及不是模拟登录
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      const mockLogin = Cookies.get(CookieKeys.cookie_insert_log) === 1;
      return userInfo.memberLevel > 5 && !mockLogin;
    },
  },
  {
    code: AUTH_KEY_MAP.SUBSCRIBE_SHOW_REMAINING, // 订阅创建是否展示剩余条数，是否有创建权限，并且 不是2.5账号，或者不死子账号
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.roleId === 2;
    },
  },
  {
    code: AUTH_KEY_MAP.FREE_USERS_CREATE_SUB, // 免费用户创建子账号
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel <= 5;
    },
    is_valid: false,
    err_msg: () => {
      return `请联系专属客服开通此功能`;
    },
  },
  {
    code: AUTH_KEY_MAP.MONITOR_SATISFACTION_SURVEY_MODE, //企业监控满意度调研 付费用户及不是模拟登录
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      const mockLogin = Cookies.get(CookieKeys.cookie_insert_log) === 1;
      return userInfo.memberLevel > 5 && !mockLogin;
    },
  },
  {
    code: AUTH_KEY_MAP.IS_MEMBER, // 是否是会员
    rules: (store) => {
      const userInfo = store.getters["basic/userInfo"];
      return userInfo.memberLevel > 5;
    },
  },
  {
    code: AUTH_KEY_MAP.INFO_HAS_PURCHASE_CHECKED, // 信息类型是否有采购意向选项
    rules: (store) => {
      // 新用户无权限(9月30日后付费用户，以及免费用户) 不展示
      const userInfo = store.getters["basic/userInfo"];
      if (userInfo.memberLevel <= 5 || !userInfo.memberOpenTime || userInfo.memberOpenTime > "2023-09-30") {
        return false;
      } else {
        return true;
      }
    },
  },
  {
    code: AUTH_KEY_MAP.IS_NEW_REGISTER_USER, // 是否是新注册用户
    rules: (store) => {
      // 从上线时间（2023-10-30日起，新注册用户不展示返回旧版按钮）
      const userInfo = store.getters["basic/userInfo"];
      if (userInfo.registerTime > "2023-10-30") {
        return true;
      } else {
        return false;
      }
    },
  },
  {
    code: AUTH_KEY_MAP.HAS_PRODUCT_SERVICES_HEADER, // 产品服务-顶部
    rules: (store) => store.getters["basic/userInfo"].memberLevel <= 5,
  },
];
